

import { claimCleaner } from "../../Claims/_common/cleaner";
import { claimContextProvider } from "../../Claims/_common/context-providers";
import { throwValidatorNotImplemented } from "./validators";


export const testDefaults = {
  contextProvider: claimContextProvider,
  validator:       throwValidatorNotImplemented,
  cleaner:         claimCleaner
}
